const app = require('app');
const Marionette = require('backbone.marionette'),
    template = require('./badBrowserModalView.hbs'),
    M = require('shared/messages/messages'),
    Radio = require('backbone.radio'),
    setCookie = require('shared/helpers/setCookie');

module.exports = Marionette.View.extend({
    template: template,
    ui: {
        continue: '#continue',
        badBrowserModal: '#badBrowserModal'
    },
    events: {
        'click @ui.continue': 'onContinue',
    },
    templateContext: function() {
        return {
            M: M,
        };
    },
    initialize: function(options) {
        options = options || {};
        this.channel = Radio.channel('login');
        this.listenTo(this.channel, 'badBrowser', this.showSelf);
    },
    showSelf: function() {
        this.ui.badBrowserModal.modal('show');
    },
    onContinue: function() {
        setCookie('badBrowserConfirmed', true);
        this.ui.badBrowserModal.modal('hide');
    },
});
